<template>
  <div class="card mb-3 cart-item" style="background-color: #EFF1F3;">
    <div class="card-body d-flex align-items-center">
      <div class="flex-grow-1">
        <h6 class="card-title mb-1" style="font-size: 0.9rem;">  {{ DBitems.product.name }} </h6>
        <p class="card-text mb-2" style="font-size: 0.85rem;">
           <strong  v-if="item.jellwery">
            {{calculateItemPrice(item.jellwery)}} 
          </strong>
          <strong  v-else-if="item.offer_price != 0">
            {{ ((item.offer_price/item.quantity)*$store.state.rate).toFixed($store.state.digit_price)}} 
          </strong>
          <strong  v-else>
            {{ ((item.total_price/item.quantity)*$store.state.rate).toFixed($store.state.digit_price)}} 
          </strong>
        
        </p>

        <!-- Quantity Control -->
        <div class="input-group input-group-sm">
          <button class="btn btn-outline-secondary" type="button" @click="decrementClick()">−</button>
          <input id="quantityInput" type="text" class="form-control text-center" :value="item.quantity" style="max-width: 40px;"
            readonly>
          <button class="btn btn-outline-secondary plus" type="button" @click="incrementClick()">+</button>
        </div>
      </div>

      <!-- Product Image -->
      <div class="ms-3">
        <img :src="DBitems.product.image" :alt="DBitems.product.name" class="img-fluid rounded"
          style="width: 70px; height: 70px;">
      </div>

      <!-- Remove Product Button -->
      <button type="button" @click="deleteItem()" class="btn btn-sm btn-light ms-2 remove-item"
        style="font-size: 1rem;">×</button>
    </div>


    <Transition name="modal">
      <div v-if="show" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">{{ $t('confirmdelete') }}</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="deleteItem()">{{ $t('confirm') }}</button>
                <button class="modal-default-button" @click="(show = false), $emit('close')">{{ $t('cancel') }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  props: {
    itemId: String
  },
  data: function () {
    return {
      loading: false,
      DBitems: null,
      item: null,
      show: false
    };
  },
  created() {
    this.loading = true;
    this.item = this.$cookies.get(this.itemId);
    if (this.item != null) {
      //console.log(this.item)
      this.axios
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/cart_item",
          {
            product_id: this.item.product_id,
            final_option: this.item.final_option,
            option_check: this.item.option_check
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.DBitems = response.data.data;
          /*if (this.sections.size > 7) {
          if (document.documentElement.getAttribute("dir") === "rtl") {
            this.sections = this.sections.slice().reverse();
          }
        }*/
        })
        .then(() => (this.loading = false));
    }
  },
  methods: {
    incrementClick() {
      // ++this.counterVal;
      console.log(
        "incrementtt" + this.item.quantity + " " + this.item.quantityAll
      );



      //////////////////////////////////////////////////////////
      let S_name_full =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option +
        this.item.option_check;

      let S_name =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option;
      console.log("S_name " + S_name);

      let qun = this.item.quantityAll;
      console.log('qun****************', qun)
      let min_qun = this.item.min_quantity;


      let max_qun = this.item.max_quantity;
      console.log("this.item.quantityAll" + this.item.quantityAll);

      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].includes(S_name)) {
          if (AllCookies[i] == S_name_full) {
            console.log("hii i am there ");
          } else {
            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
            min_qun = this.$cookies.get(AllCookies[i]).min_quantity;
            max_qun = this.$cookies.get(AllCookies[i]).max_quantity;
            console.log(
              this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
            );

            console.log(
              this.$cookies.get(AllCookies[i]).min_quantity + " min quuuuun " + min_qun
            );
          }
        }
      }
      //////////////////////////////////////////////////////////
      if (this.item.quantityAll > 0) {
        if (this.item.quantity < qun
          && this.item.quantity < max_qun
          // && this.item.quantity > min_qun
        ) {
          ++this.item.quantity;
          this.item.total_price =
            this.item.total_price / (this.item.quantity - 1) +
            this.item.total_price;
          /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
          if (this.item.offer_price != 0) {
            this.item.offer_price =
              this.item.offer_price / (this.item.quantity - 1) +
              this.item.offer_price;
          }

          //////////update this key
          let product = {
            product_id: this.item.product_id,
            total_price: this.item.total_price,
            offer_price: this.item.offer_price,
            quantity: this.item.quantity,
            quantityAll: this.item.quantityAll,
            min_quantity: this.item.min_quantity,
            max_quantity: this.item.max_quantity,
            final_option: this.item.final_option,
            option_check: this.item.option_check,
            discount: this.item.discount,
            note: this.item.note
          };
          this.$cookies.set(this.itemId, product);
          this.$parent.updateProducts();
        }
      } else {
        ++this.item.quantity;
        this.item.total_price =
          this.item.total_price / (this.item.quantity - 1) +
          this.item.total_price;
        /* if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price / (this.item.quantity - 1) +
            this.item.offer_price;
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    decrementClick() {
      let min_qun = this.item.min_quantity;
      let max_qun = this.item.max_quantity;
      console.log(
        "decrementttt" + this.item.quantity + " ", this.item
      );
      if (this.item.quantity > 1
        && (this.item.quantity > min_qun ||min_qun==null)
      ) {
        //  --this.counterVal;
        --this.item.quantity;
        //this.price = this.price/2
        this.item.total_price =
          this.item.total_price -
          this.item.total_price / (this.item.quantity + 1);
        /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price -
            this.item.offer_price / (this.item.quantity + 1);
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          min_quantity: this.item.min_quantity,
          max_quantity: this.item.max_quantity,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    deleteItem() {
      //this.loading = true;
      this.$cookies.remove(this.itemId);
      console.log("remove" + this.$cookies.keys());
      if(this.$store.state.cartCounter>0)
      this.$store.state.cartCounter = this.$store.state.cartCounter - 1;
      this.$destroy();
      this.$parent.updateProducts();
      this.$el.parentNode.removeChild(this.$el);
    },
     calculateItemPrice(item) {
      let basePrice = item.type === "gold" ? this.$store.state.gold.qar_ask:
      this.$store.state.silver.qar_ask; // السعر على أساس عيار 24
      let purityFactor =  item.purity / 24;
      let manufacturing = Number(item.gold_manufacturing || 0);
      let countGram = Number(item.count_gram || 1);

      return ((((basePrice * purityFactor) + manufacturing) * countGram).toFixed(2))*this.item.quantity;
    },
  }
};


</script>